import { render, staticRenderFns } from "./SubscribedAccount.vue?vue&type=template&id=948c7d12"
import script from "./SubscribedAccount.vue?vue&type=script&lang=js"
export * from "./SubscribedAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports